export enum Language {
  EN = 'en',
  ZH = 'zh',
}

export enum LanguageLabel {
  ENGLISH = 'EN',
  CHINESE = '中文',
}

export interface LanguageConfig {
  value: Language;
  label: LanguageLabel;
}

export const LANGUAGES_CONFIG: LanguageConfig[] = [
  {
    value: Language.EN,
    label: LanguageLabel.ENGLISH,
  },
  {
    value: Language.ZH,
    label: LanguageLabel.CHINESE,
  },
];
